import { useEffect } from "react";
import { miscSlice } from "redux/slices/miscSlice";
import { useDispatch } from "react-redux";
import { useFetch } from "lib/useFetch";
import { useProdCopyUrl } from "components/PreferencesDialog/redesignUtils";
import { mutateHighlightFields, parsePublications } from "./parsePublicationResponse";
import { createFeaturedPubRequestBody } from "./createFeaturedPubRequestBody";

const jsApiUrl = (prodCopyUrl) => `/research/${prodCopyUrl}/pub/search/query`;

export const useFetchFeaturedPublications = (searchRequest) => {
  const body = createFeaturedPubRequestBody(searchRequest);
  const prodCopyUrl = useProdCopyUrl();
  const response = useFetch(jsApiUrl(prodCopyUrl), JSON.stringify(body));
  const searchResults = tryParse(response);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(miscSlice.actions.set({ key: "featuredResults", value: searchResults }));
  });
  return searchResults;
};

function tryParse([data, isLoading, isError]) {
  try {
    mutateHighlightFields(data);
    const hits = parsePublications(data);
    const totalHits = data?.hits?.total?.value;

    return [hits, isLoading, isError, totalHits];
  } catch (err) {
    console.error("Error parsing publication data: ", err, data);
    return [null, null, true, null, null];
  }
}
